<template>
  <q-dialog v-model="opened" @show="onShow" >
    <q-card>
      <q-card-section>
        <div class="text-h6">Select a Note Template</div>
      </q-card-section>
      <q-card-section class="q-px-sm">
          <q-input ref="searchBox" inverted v-model="searchTerm" dense
                   @keyup.down="downPressed"
                   @keyup.up="upPressed"
                   @keyup.enter="enterPressed" color="none" :debounce="50" label="Search" style="width: 100%;"/>
      </q-card-section>
      <q-card-section style="max-height: 50vh" class="scroll q-pa-none">
        <q-list link class="bg-white">
          <q-item clickable class="q-ma-sm" @click.native="close(null)" ref="noneitem"
                  :active="selectedId === 0" active-class="bg-teal-1 text-black" >
            <q-item-section>
              None
            </q-item-section>
          </q-item>
          <q-item clickable v-for="(noteTemplate, i) in filteredNoteTemplates"
                  :key="noteTemplate.id"
                  :active="selectedId === (i+1)" active-class="bg-teal-1 text-black"
                  class="q-ma-sm"
                  @click.native="close(noteTemplate)">
            <q-item-section>
              {{noteTemplate.name}}
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

export default {
  // name: 'ComponentName',
  data () {
    return {
      opened: false,
      responsePromise: null,
      resolvePromise: null,
      rejectPromise: null,
      selectedId: 0,
      searchTerm: ''
    }
  },
  computed: {
    filteredNoteTemplates () {
      const _vm = this
      return this.enabledNoteTemplates.filter((nt) => {
        return nt.name.toLowerCase().includes(_vm.searchTerm.toLowerCase())
      })
    },
    enabledNoteTemplates () { return this.$store.getters.getNoteTemplatesAsAry.filter(nt => nt.enabled) }
  },
  methods: {
    show () {
      this.opened = true
      // this.cmOptions.origRight = null
      let t = this
      this.responsePromise = new Promise((resolve, reject) => {
        t.resolvePromise = resolve
        t.rejectPromise = reject
      })

      return this.responsePromise
    },
    cancel () {
      this.rejectPromise()
      this.opened = false
    },
    close (noteTemplate) {
      this.resolvePromise(noteTemplate)
      this.opened = false
    },
    onShow () {
      this.$nextTick(() => {
        this.$refs.searchBox.focus()
      })
    },
    upPressed () {
      if (this.selectedId <= 0) this.selectedId = 0
      else this.selectedId -= 1
    },
    downPressed () {
      if (this.selectedId >= this.filteredNoteTemplates.length) this.selectedId = this.filteredNoteTemplates.length
      else this.selectedId += 1
    },
    enterPressed () {
      if (this.selectedId === 0) {
        this.resolvePromise(null)
      } else {
        this.resolvePromise(this.filteredNoteTemplates[this.selectedId - 1])
      }
    }
  },
  mounted () {
    // let items = [1, 2, 3, 4, 5, 6]
    // items.forEach(i => {
    //   this.myArray.push({
    //     name: i,
    //     id: i
    //   })
    // })
  }
}
</script>

<style>
</style>
